<template lang="pug">
  div(v-cloak)
    v-layout(row, wrap)
      v-flex(xs12, sm6, md3)
        v-card
          v-card-title.primary
            | 入力内容
          v-card-text
            .app-line
              span.app-line-title 寸法基準
              span.app-line-text {{box.input.measurement.method.name}}
              span.app-line-suffix
            .app-line
              span.app-line-title 幅
              span.app-line-text {{box.input.measurement.width}}
              span.app-line-suffix mm
            .app-line
              span.app-line-title 高さ
              span.app-line-text {{box.input.measurement.height}}
              span.app-line-suffix mm
            .app-line
              span.app-line-title 奥行
              span.app-line-text {{box.input.measurement.depth}}
              span.app-line-suffix mm
            .app-line
              span.app-line-title 天板
              span.app-line-text(v-if="box.input.option.faces.top")
                | {{box.input.osb.top.width}} x
                | {{box.input.osb.top.length}} x
                | {{box.input.osb.top.thick}}
              span.app-line-text(v-else) なし
              span.app-line-suffix
            .app-line
              span.app-line-title 側板
              span.app-line-text(v-if="box.input.option.faces.side")
                | {{box.input.osb.side.width}} x
                | {{box.input.osb.side.length}} x
                | {{box.input.osb.side.thick}}
              span.app-line-text(v-else) なし
              span.app-line-suffix
            .app-line
              span.app-line-title 底板
              span.app-line-text(v-if="box.input.option.faces.bottom")
                | {{box.input.osb.bottom.width}} x
                | {{box.input.osb.bottom.length}} x
                | {{box.input.osb.bottom.thick}}
              span.app-line-text(v-else) なし
              span.app-line-suffix
            .app-line
              span.app-line-title 天板・側板
              span.app-line-text {{box.input.edge_group.top_side.name}}
              span.app-line-suffix
            .app-line
              span.app-line-title 側板・側板
              span.app-line-text {{box.input.edge_group.side_side.name}}
              span.app-line-suffix
            .app-line
              span.app-line-title 底板・側板
              span.app-line-text {{box.input.edge_group.bottom_side.name}}
              span.app-line-suffix
            .app-line
              span.app-line-title 桁
              span.app-line-text {{box.input.option.clog.name}}
              span.app-line-suffix
            div(v-if='box.input.option.clog.calculate')
              .app-line(v-if='box.input.option.clog.deck === 0')
                span.app-line-title 桁本数
                span.app-line-text {{box.input.option.clog_num}}
                span.app-line-suffix 本
              .app-line(v-if='box.input.option.clog.deck === 0')
                span.app-line-title クリアランス
                span.app-line-text {{box.input.option.clog_clearance}}
                span.app-line-suffix mm
              .app-line(v-if='box.input.option.clog.deck === 1')
                span.app-line-title ブロック個数
                span.app-line-text W:{{box.input.option.clog_w_blocks}}個 x D:{{box.input.option.clog_d_blocks}}個
                span.app-line-suffix
              .app-line(v-if='')
                span.app-line-title {{box.input.option.clog.deck === 0 ? '桁渡し方向' : 'デッキ方向'}}
                span.app-line-text {{box.input.option.clog_deck_direction.name}}
                span.app-line-suffix
            .app-line
              span.app-line-title 側板補強
              span.app-line-text {{box.input.option.side_support.name}}
              span.app-line-suffix
            .app-line
              span.app-line-title クランプ
              span.app-line-text {{box.input.option.clamp.name}}
              span.app-line-suffix
            .app-line(v-if='box.input.option.clamp_pitch_input')
              span.app-line-title 指定ピッチ
              span.app-line-text {{box.input.option.clamp_pitch}}
              span.app-line-suffix mm
            .app-line
              span.app-line-title バックル/ベルト
              span.app-line-text {{box.input.option.buckle.name}}
              span.app-line-suffix
            .app-line(v-if='box.input.option.buckle.calculate')
              span.app-line-title バックル/ベルト本数
              span.app-line-text {{box.input.option.buckle_num}}
              span.app-line-suffix 本
            div(v-for='stamp in box.input.option.stamps', :key='stamp.id')
              .app-line
                span.app-line-title スタンプ
                span.app-line-text {{stamp.name}}
                span.app-line-suffix
            .app-line
              span.app-line-title 積み重ね
              span.app-line-text {{box.input.overview.stack ? 'あり': 'なし'}}
              span.app-line-suffix &nbsp;
            .app-line
              span.app-line-title 個数
              span.app-line-text {{box.input.overview.quantity}}
              span.app-line-suffix 個
            .app-line
              span.app-line-title 原価率
              span.app-line-text {{box.input.overview.cost_rate}}
              span.app-line-suffix ％
            .app-line
              span.app-line-title 商品名
              span.app-line-text {{box.input.overview.item_name}}
              span.app-line-suffix
            .app-line
              span.app-line-title 備考
              span.app-line-text {{box.input.overview.description}}
              span.app-line-suffix
            .app-line
              span.app-line-title 注釈
              span.app-line-text {{box.input.overview.comment}}
              span.app-line-suffix

      v-flex(xs12, sm6, md3)
        v-card
          v-card-title.primary プレビュー
          v-card-text.pa-1.preview-card
            img(:src='box.image', width='100%')
            v-btn.preview-3d(raised, color='primary', icon, large, @click.stop='preview')
              v-icon 3d_rotation
            v-btn.reload-image(flat, color='warning', icon, @click.stop='reloadImage', v-if='hasTrial')
              v-icon refresh
            v-dialog(v-model='previewDialog', transition='dialog-bottom-transition', :fullscreen='isMobile', :width='isMobile ? 380 : 620')
              v-toolbar.primary(dense)
                v-spacer
                v-btn(flat icon small @click.stop='closePreview')
                  v-icon close
              v-card.dialog-card
                .preview-canvas(:id="'preview-canvas-' + uniqueIndex")
        v-card.mt-1
          v-card-title.primary 立米情報
          v-card-text
            .app-line
              span.app-line-title 内寸
              span.app-line-text {{box.m3.inner|number(4)}}
              span.app-line-suffix
                | m
                sup 3
            .app-line
              span.app-line-title 外寸
              span.app-line-text {{box.m3.outer|number(4)}}
              span.app-line-suffix
                | m
                sup 3
            .app-line
              span.app-line-title
                span 単価
                span.app-line-title-suppliment 外寸立米
              span.app-line-text
                span(v-if='box.input.override && box.input.override.is_price_override && box.m3.cost !== box.m3.fixed_cost')
                  v-icon(color='warning') edit
                  s {{box.m3.cost|number}}
                span {{box.m3.fixed_cost|number}}
              span.app-line-suffix
                | 円/m
                sup 3

      v-flex(xs12, sm6, md3)
        v-card
          v-card-title.primary 原板別使用情報
          v-card-text
            div(v-for='(osb, index) in box.order_osbs', :key='index')
              .app-lines-header
                span {{osb.osb.thick}} mm
              .app-line
                span.app-line-title 面積
                span.app-line-text {{osb.square|number(4)}}
                span.app-line-suffix
                  | m
                  sup 2
              .app-line
                span.app-line-title 原価
                span.app-line-text {{osb.unit_cost|number(2)}}
                span.app-line-suffix 円
              .app-line
                span.app-line-title 重量
                span.app-line-text {{osb.weight|number(2)}}
                span.app-line-suffix kg
        v-card.mt-1(v-if='box.input.specials.length > 0')
          v-card-title.primary 特注オプション
          v-card-text
            .app-line(v-for='(special, index) in box.input.specials', :key='index')
              span.app-line-title # {{index + 1}} {{special.title}}
              span.app-line-text
                span {{special.amount|number(2)}}
              span.app-line-suffix 円
        v-card.mt-1(v-if='box.input.appendices.length > 0')
          v-card-title.primary 別枠追加明細
          v-card-text
            .app-line(v-for='(appendix, index) in box.input.appendices', :key='index')
              span.app-line-title # {{index + 1}} {{appendix.title}}
              span.app-line-text
                span {{appendix.unit_cost|number}} x {{appendix.quantity|number}} {{appendix.unit.name}} =
                span {{appendix.amount|number(2)}}
              span.app-line-suffix 円
        v-card.mt-1
          v-card-title.primary その他
          v-card-text
            .app-line
              span.app-line-title 合計クランプ数
              span.app-line-text {{box.clamps.total|number}}
              span.app-line-suffix 個
        v-card.mt-1(v-if='hasTrial')
          v-card-title.warning 商品名・備考・注釈更新
          v-card-text
            v-text-field(type='text', label='商品名', :value='box.input.overview.item_name', @input="setTrialOverview({'item_name': $event})", autocapitalize='off')
            v-text-field(type='text', label='備考', :value='box.input.overview.description', @input="setTrialOverview({'description': $event })", autocapitalize='off', persistent-hint, :hint="'参考再販価格 : ' + endUserPrice + ' 円'")
            v-text-field(type='text', label='注釈', :value='box.input.overview.comment', @input="setTrialOverview({'comment': $event })", autocapitalize='off', persistent-hint, hint='注釈は箱の明細欄にのみ表示されます。')

      v-flex(xs12, sm6, md3)
        v-card(v-if='hasTrial')
          v-card-title.warning 手入力単価補正
          v-card-text
            v-switch(
              label='単価補正'
              :input-value='trialOverride.is_price_override'
              @change='changeOverrideSwitch($event)'
              hide-details
            )
            v-layout(row, wrap, v-if='trialOverride.is_price_override')
              v-flex(xs8)
                v-text-field(
                  type='number'
                  label='補正単価'
                  :value='trialOverride.overridden_price'
                  @input="setTrialOverride({'overridden_price': $event})"
                  ref='overridden_price'
                  :rules='[rules.required,rules.integer,rules.positive]'
                  autocapitalize='off'
                  suffix='円'
                )
              v-flex(xs4)
                v-btn(flat, color='warning', @click.stop='applyOverride')
                  i.fa.fa-fw.fa-lg.fa-check
                  span 適用
        v-card(:class="hasTrial ? 'mt-1': ''")
          v-card-title.primary 箱単位計算結果
          v-card-text
            .app-line
              span.app-line-title 重量
              span.app-line-text {{box.weight.per_box|number(2)}}
              span.app-line-suffix kg
            .app-line.blue.lighten-3
              span.app-line-title 原価
              span.app-line-text {{box.summary.unit_cost|number(2)}}
              span.app-line-suffix 円
            .app-line
              span.app-line-title 原価率
              span.app-line-text {{box.summary.pure_cost_rate|number(2)}}
              span.app-line-suffix ％
            .app-line
              span.app-line-title 単価
              span.app-line-text {{box.summary.pure_price|number(2)}}
              span.app-line-suffix 円
            .app-line
              span.app-line-title 確定原価率
              span.app-line-text
                span(v-if='box.input.override && box.input.override.is_price_override && box.summary.ceiled_cost_rate !== box.summary.fixed_cost_rate')
                  v-icon(color='warning') edit
                  s {{box.summary.ceiled_cost_rate|number(2)}}
                span {{box.summary.fixed_cost_rate|number(2)}}
              span.app-line-suffix ％
            .app-line.green.lighten-3
              span.app-line-title 確定単価
              span.app-line-text
                span(v-if='box.input.override && box.input.override.is_price_override && box.summary.ceiled_price !== box.summary.fixed_price')
                  v-icon(color='warning') edit
                  s {{box.summary.ceiled_price|number(2)}}
                span {{box.summary.fixed_price|number(2)}}
              span.app-line-suffix 円
            .app-line
              span.app-line-title 利益率
              span.app-line-text {{100 - box.summary.fixed_cost_rate|number(2)}}
              span.app-line-suffix ％
            .app-line.amber.lighten-3
              span.app-line-title 利益
              span.app-line-text {{box.summary.fixed_price - box.summary.unit_cost|number(2)}}
              span.app-line-suffix 円
        v-card.mt-1
          v-card-title.success 計算結果
          v-card-text
            .app-line
              span.app-line-title 個数
              span.app-line-text {{box.input.overview.quantity|number}}
              span.app-line-suffix 個
            .app-line
              span.app-line-title 小計
              span.app-line-text
                span(v-if='box.input.override && box.input.override.is_price_override && box.summary.amount !== box.summary.fixed_amount')
                  v-icon(color='warning') edit
                  s {{box.summary.amount|number(2)}}
                span {{box.summary.fixed_amount|number(2)}}
              span.app-line-suffix 円
            .app-line
              span.app-line-title 総重量
              span.app-line-text
                span {{box.weight.total|number(2)}}
              span.app-line-suffix kg
            .app-line
              span.app-line-title 合計
              span.app-line-text
                span(v-if='box.input.override && box.input.override.is_price_override && box.summary.amount !== box.summary.fixed_amount')
                  v-icon(color='warning') edit
                span {{box_total|number(2)}}
              span.app-line-suffix 円
      v-flex(xs12)
        box-detail(:box='box')

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Three, { Box, Frame, Size, Thick, Face, ClogFactory } from './Three'
import _ from 'underscore'
import mathjs from 'mathjs'
import rules from '@/common/mixins/rules'
import BoxDetail from './BoxDetail'

export default {
  props: ['index', 'token', 'boxIndex'],
  components: {
    BoxDetail
  },
  data () {
    return {
      box: null,
      previewDialog: false
    }
  },
  mixins: [rules],
  created () {
    this.box =
      typeof this.index === 'number'
        ? this.getBox(this.index)
        : this.token && typeof this.boxIndex === 'number'
          ? this.getListBox(this.token, this.boxIndex)
          : this.trial
  },
  mounted () {},
  beforeDestroy () {},
  watch: {
    previewDialog: v => {
      if (!v) {
        Three.deactivate()
      }
    }
  },
  computed: {
    isMobile () {
      return window.innerWidth < 600
    },
    ...mapGetters('app/order', [
      'getBox',
      'trial',
      'hasTrial',
      'trialOverride',
      'trialSummary'
    ]),
    ...mapGetters('app/list', { getListBox: 'getBox' }),
    box_total () {
      let self = this
      let total = self.box.summary.fixed_amount
      _.each(self.box.input.appendices, function (appendix) {
        total = mathjs.ceil(mathjs.add(total, appendix.amount))
      })
      return total
    },
    uniqueIndex () {
      return typeof this.index === 'number'
        ? this.index
        : this.token && typeof this.boxIndex === 'number'
          ? this.token + '-' + this.boxIndex
          : 'trial'
    },
    endUserPrice () {
      let appendicesTotalUnitCost = _.chain(this.box.input.appendices)
        .pluck('unit_cost')
        .reduce(function (unitCost, sum) {
          return mathjs.add(sum, unitCost)
        }, 0)
        .value()
      return (
        mathjs.ceil(
          mathjs.ceil(
            mathjs.add(this.box.summary.fixed_price, appendicesTotalUnitCost) /
              0.8
          ) / 10
        ) * 10
      )
    }
  },
  methods: {
    ...mapActions('app/order', [
      'setTrialOverride',
      'setTrialSummary',
      'setTrialM3',
      'setTrial',
      'setTrialOverview'
    ]),
    changeOverrideSwitch (isPriceOverride) {
      if (isPriceOverride) {
        this.setTrialOverride({
          is_price_override: isPriceOverride
        })
        this.applyOverride()
      } else {
        this.setTrialOverride({
          is_price_override: isPriceOverride
        })
        this.setTrialSummary({
          fixed_cost_rate: this.box.summary.ceiled_cost_rate,
          fixed_price: this.box.summary.ceiled_price,
          fixed_amount: this.box.summary.amount
        })
        this.setTrialM3({
          fixed_cost: this.box.m3.cost
        })
      }
    },
    applyOverride () {
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('_rules.invalidate_message'))
        return true
      }
      let uc = this.trialSummary.unit_cost
      let p = this.trialOverride.overridden_price
      let ocr = mathjs
        .chain(uc)
        .divide(p)
        .multiply(100)
        .done()
      let overriddenCostRate = mathjs.ceil(ocr * 100) / 100

      this.setTrialSummary({
        fixed_cost_rate: overriddenCostRate,
        fixed_price: p,
        fixed_amount: p * this.box.input.overview.quantity
      })
      this.setTrialM3({
        fixed_cost: mathjs.ceil(
          this.trialSummary.fixed_price / this.box.m3.outer
        )
      })
    },
    preview () {
      const option = this.box.input.option
      let div = document.getElementById(`preview-canvas-${this.uniqueIndex}`)
      Three.activate(
        new Frame(
          this.isMobile ? 340 : 580,
          this.isMobile ? 340 : 580,
          false,
          div
        ),
        new Box(
          new Size(
            this.box.outer.width,
            this.box.outer.height,
            this.box.outer.depth
          ),
          new Thick(
            this.box.input.osb.top.thick,
            this.box.input.osb.side.thick,
            this.box.input.osb.bottom.thick
          ),
          new Face(option.faces.top, option.faces.side, option.faces.bottom),
          new Size(
            this.box.clamps.width,
            this.box.clamps.height,
            this.box.clamps.depth
          ),
          new Size(
            this.box.order_clamp.clamp.size_x,
            this.box.order_clamp.clamp.size_y,
            this.box.order_clamp.clamp.size_z
          ),
          ClogFactory.create(
            option.clog.calculate === 1,
            option.clog.width,
            option.clog.height,
            option.clog.deck === 1,
            option.clog_num,
            option.clog_clearance,
            option.clog_w_blocks,
            option.clog_d_blocks,
            option.clog_deck_direction.direction
          )
        )
      ).then(() => {
        this.previewDialog = true
      })
    },
    closePreview () {
      this.previewDialog = false
    },
    reloadImage () {
      const option = this.box.input.option
      Three.createImage(
        new Frame(320, 320, true),
        new Box(
          new Size(
            this.box.outer.width,
            this.box.outer.height,
            this.box.outer.depth
          ),
          new Thick(
            this.box.input.osb.top.thick,
            this.box.input.osb.side.thick,
            this.box.input.osb.bottom.thick
          ),
          new Face(option.faces.top, option.faces.side, option.faces.bottom),
          new Size(
            this.box.clamps.width,
            this.box.clamps.height,
            this.box.clamps.depth
          ),
          new Size(
            this.box.order_clamp.clamp.size_x,
            this.box.order_clamp.clamp.size_y,
            this.box.order_clamp.clamp.size_z
          ),
          ClogFactory.create(
            option.clog.calculate === 1,
            option.clog.width,
            option.clog.height,
            option.clog.deck === 1,
            option.clog_num,
            option.clog_clearance,
            option.clog_w_blocks,
            option.clog_d_blocks,
            option.clog_deck_direction.direction
          )
        )
      ).then(image => {
        this.setTrial({ image: image })
      })
    }
  }
}
</script>

<style scoped lang="stylus">
s {
  color: grey;
}

.preview-canvas {
  padding: 20px;
  z-index: 9999;
}

.preview-card {
  position: relative;

  .preview-3d {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .reload-image {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Components/Box.vue